import { Tabs, Tab } from '@theneatcompany/nui'

export default Tabs
export { Tab }
